import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Home from './containers/Home.vue'
import Brandest from './containers/Brandest/Brandest.vue'
import GalaxyBirds from './containers/GalaxyBirds/GalaxyBirds.vue'
import Puzzle from './containers/Puzzle/Puzzle'
import SmartBlocks from './containers/SmartBlocks/SmartBlocks'
import Signature from './containers/Signature/Signature'
import Tos from './containers/Puzzle/components/Tos'

import PrivacyPolicy from './containers/Puzzle/components/PrivacyPolicy'

const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/",
            component: Home,
            name: "Home",
            meta: { title: 'Profuse' }
        },
        {
            path: "/brandest",
            component: Brandest,
            name: "Brandest",
            meta: { title: 'Brandest' }
        },
        {
            path: "/galaxy-birds",
            component: GalaxyBirds,
            name: "GalaxyBirds",
            meta: { title: 'Galaxy Birds' }
        },
        {
            path: "/brain-puzzle",
            component: Puzzle,
            name: "Puzzle",
            meta: { title: 'Puzzle' }
        },
        {
            path: "/smart-blocks",
            component: SmartBlocks,
            name: "SmartBlocks",
            meta: { title: 'Smart Blocks' }
        },
        {
            path: "/signature-stamp",
            component: Signature,
            name: "Signature",
            meta: { title: 'Signature' }
        },
        {
            path: "/privacy-policy",
            component: PrivacyPolicy,
            name: "PrivacyPolicy",
            meta: { title: 'Privacy' }
        },
        {
            path: "/tos",
            component: Tos,
            name: "Tos",
        }
    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
    console.log(to, from, next)
    document.title = to.meta.title
    next()
  })

export default router;